//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.CustomAttribute.js";
let d=[[[0,"Unit",1,"Unit",0]],[[["doubleValues"],"SetValues",{},1,0],[["numValues"],"GetValues",{R_:{doubleValues:""}},0,0],[["doubleValues","unit"],"SetValuesWithUnit",{},2,0],[["numValues","unit"],"GetValuesWithUnit",{R_:{doubleValues:""}},0,0]],[]];
SPLM.Features.CustomDoubleArrayAttribute = class extends SPLM.Features.CustomAttribute{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.CustomDoubleArrayAttribute";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;